import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './UI/LoadingSpinner';

const ProtectedRoute = ({ children, requireSupervisor = false }) => {
    const { isAuthenticated, isSupervisor, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
        <div className="min-h-screen flex items-center justify-center">
            <LoadingSpinner size="lg" text="Verificando autenticación..." />
        </div>
        );
    }

    if (!isAuthenticated) {
        // Redirigir al login, guardando la ubicación desde donde venían
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireSupervisor && !isSupervisor) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="text-center max-w-md p-6 bg-white rounded-lg shadow-md">
					<div className="text-yellow-500 text-6xl mb-4">⚠️</div>
					<h2 className="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h2>
					<p className="text-gray-600 mb-4">
						No tienes permisos suficientes para acceder a esta página.
					</p>
					<button
						onClick={() => window.history.back()}
						className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
					>
						Volver Atrás
					</button>
				</div>
			</div>
		);
    }

  	return children;
};

export default ProtectedRoute;